<template>
  <page-wrapper :title="title">
    <div class="header" v-if="!$isCallCenter">
      <sc-button
        class="create-button"
        variant="primary"
        :route="{ name: 'ServiceCreatePage' }"
        >เพิ่มบริการ</sc-button
      >
      <sc-button
        variant="secondary"
        :route="{ name: 'MultipleServiceUnavailableDatePage' }"
        >ลงวันไม่ว่างของหลายบริการ</sc-button
      >
    </div>
    <div class="container-fluid filter-form">
      <div class="row ml-3 mr-3 pt-3">
        <div class="mb-3">
          <br />
          <el-radio
            v-model="query.filterType"
            :label="filterToType.NORMAL"
            @change="handleChangeFilterType()"
            >&nbsp;</el-radio
          >
        </div>
        <div class="col-lg-3 mb-3">
          <label class="search-service">ชื่อบริการ</label>
          <el-input
            v-model="query.name"
            :disabled="query.filterType === filterToType.UNAVAILABLE"
          ></el-input>
        </div>
        <div class="col-lg-2 mb-3">
          <label class="search-service">ผู้ให้บริการ</label>
          <provider-selector
            v-model="selectedProvider"
            :disabled="query.filterType === filterToType.UNAVAILABLE"
          ></provider-selector>
        </div>
        <div>
          <br />
          <el-divider direction="vertical"></el-divider>
        </div>
        <div class="mb-3">
          <br />
          <el-radio
            v-model="query.filterType"
            :label="filterToType.UNAVAILABLE"
            @change="handleChangeFilterType()"
            >&nbsp;</el-radio
          >
        </div>
        <div class="col-lg-3 mb-3">
          <label class="search-service"
            >เลือกประเภทวันที่ไม่สามารถนัดหมายบริการ</label
          >
          <el-select
            v-model="query.filterTypeOfUnavailableDate"
            :disabled="query.filterType === filterToType.NORMAL"
            @change="handleChangeFilterTypeOfUnavailableDate()"
            clearable
          >
            <el-option
              v-for="t in dateType"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
        <div class="col-lg-3 mb-3" v-if="query.filterTypeOfUnavailableDate">
          <div
            v-if="query.filterTypeOfUnavailableDate === dateTypeMapping.MONTH"
          >
            <div class="date-calendar">
              <el-checkbox-group
                v-model="queryByUnavailableDate.unavailableWorkdaysInMonth"
              >
                <el-checkbox-button
                  v-for="date in dateOfMonth"
                  :label="date"
                  :key="date"
                  >{{ date }}</el-checkbox-button
                >
              </el-checkbox-group>
            </div>
          </div>
          <div
            v-else-if="
              query.filterTypeOfUnavailableDate === dateTypeMapping.DATE
            "
          >
            <div>
              <label class="search-service">เลือกวันที่</label>
              <date-picker
                :value="queryByUnavailableDate.unavailableDate"
                @input="handleChangeSelectedUnavailableDate($event)"
              ></date-picker>
            </div>
          </div>
          <div
            v-else-if="
              query.filterTypeOfUnavailableDate === dateTypeMapping.TIME
            "
          >
            <div>
              <label class="search-service">เลือกช่วงเวลา</label>
              <div class="time-calendar">
                <el-checkbox-group
                  v-model="queryByUnavailableDate.unavailableTimes"
                >
                  <el-checkbox-button
                    v-for="time in timeOfDay"
                    :label="time.value"
                    :key="time.value"
                    >{{ time.label }}</el-checkbox-button
                  >
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <div
            v-else-if="
              query.filterTypeOfUnavailableDate === dateTypeMapping.WEEK
            "
          >
            <div>
              <label class="search-service">ทุก ๆ วัน</label>
              <div class="day-calendar">
                <el-checkbox-group
                  v-model="queryByUnavailableDate.unavailableWorkdaysInWeek"
                >
                  <el-checkbox-button
                    v-for="day in daysOfWeek"
                    :label="day.value"
                    :key="day.value"
                    >{{ day.label }}</el-checkbox-button
                  >
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ml-3 mr-3 pb-3 text-right">
        <sc-button variant="secondary" @click="handleClickSearchButton"
          >ค้นหา</sc-button
        >
      </div>
    </div>

    <div class="wrapper">
      <div class="container" v-if="query.filterType === filterToType.NORMAL">
        <p class="mb-2 mt-2">{{ totalCount }}</p>
        <service-list-item
          v-for="item in list"
          :key="item.id"
          v-bind="item"
        ></service-list-item>
        <div class="text-right mt-4">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="30"
            :current-page="query.page"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
      <div
        class="container"
        v-if="query.filterType === filterToType.UNAVAILABLE"
      >
        <p class="mb-2 mt-2">
          พบข้อมูลทั้งหมด {{ unavailableDateCount }} บริการ
        </p>
        <div v-if="unavailableDateList.length > 0">
          <div
            class="service-list-item"
            v-for="item in unavailableDateList"
            :key="item.id"
            v-bind="item"
          >
            <img class="icon" :src="item.iconUrl" v-if="item.iconUrl" />
            <div class="col-10 meta no-icon">
              <router-link class="name" :to="item.route" v-if="item.route">
                {{ item.name }}
              </router-link>
              <h4 class="name" v-else>{{ item.name }}</h4>
              <p class="desc">{{ item.description }}</p>
            </div>
            <div
              class="col-2"
              v-if="query.filterTypeOfUnavailableDate === dateTypeMapping.DATE"
            >
              <sc-button
                variant="secondary"
                @click="handleClickRemoveUnavailableButton(item)"
                >นัดบริการได้</sc-button
              >
            </div>
          </div>
          <div class="text-right mt-4">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="unavailableDateCount"
              :page-size="30"
              :current-page="query.page"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import {
  Select as ElSelect,
  Option as ElOption,
  Input as ElInput,
  Radio as ElRadio,
  Pagination as ElPagination,
  Divider as ElDivider,
  CheckboxButton,
  CheckboxGroup
} from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import ProviderSelector from "@/lib/components/ProviderSelector";
import ServiceListItem from "../components/ServiceListItem";
import DatePicker from "@/lib/components/DatePicker";
import { DateTime } from "luxon";
import { baanRueJaiClient } from "@/dependencies";
import {
  daysOfWeek,
  timeOfDay,
  datesOfMonth,
  dateType,
  dateTypeMapping
} from "@/lib/mapper";
import { existValueAndEmptyString } from "@/lib/util";

export default {
  components: {
    PageWrapper,
    ServiceListItem,
    ScButton,
    ElSelect,
    ElOption,
    ElInput,
    ElRadio,
    ProviderSelector,
    ElPagination,
    ElDivider,
    DatePicker,
    "el-checkbox-group": CheckboxGroup,
    "el-checkbox-button": CheckboxButton
  },
  data() {
    const title = "รายการบริการ";
    const list = [];
    const unavailableDateList = [];
    const query = {
      name: null,
      providerId: null,
      filterType: null,
      filterTypeOfUnavailableDate: null,
    };
    const selectedProvider = null;
    const total = 0;
    const queryByUnavailableDate = {
      unavailableWorkdaysInMonth: [],
      unavailableTimes: [],
      unavailableWorkdaysInWeek: [],
      unavailableDate: null
    };

    const dateOfMonth = datesOfMonth.map((date) => date.toLocaleString());

    return {
      title,
      list,
      unavailableDateList,
      query,
      selectedProvider,
      total,
      daysOfWeek,
      timeOfDay,
      dateOfMonth,
      dateType,
      dateTypeMapping,
      queryByUnavailableDate,
      filterToType: {
        UNAVAILABLE: "unavailable",
        NORMAL: "normal"
      },
      unavailableDateCount: 0
    };
  },
  computed: {
    totalCount() {
      if (this.total === 0) {
        return "ไม่พบข้อมูล";
      }

      const limit = 30;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.list.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = this.query.page;
      const end = (isLastPage ? total : currentPage * limit).toLocaleString();
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    }
  },
  watch: {
    async "$route.query"() {
      this.setupQuery();
      await this.setupData();
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupQuery();
      this.setupData();
    },
    setupQuery() {
      const routeQuery = this.$route.query;

      this.query = {
        name: routeQuery.name || null,
        providerId: routeQuery.providerId || null,
        filterType: routeQuery.filterType || this.filterToType.NORMAL,
        page: parseInt(routeQuery.page) || 1,
        filterTypeOfUnavailableDate:
          routeQuery.filterTypeOfUnavailableDate || null
      };

      if (
        existValueAndEmptyString(this.query.filterTypeOfUnavailableDate) &&
        existValueAndEmptyString(this.queryByUnavailableDate)
      ) {
        const filterTypeOfUnavailableDate = this.query.filterTypeOfUnavailableDate;

        if (
          filterTypeOfUnavailableDate === this.dateTypeMapping.TIME &&
          existValueAndEmptyString(routeQuery.unavailableTimes)
        ) {
          this.queryByUnavailableDate = {
            ...this.queryByUnavailableDate,
            unavailableTimes: routeQuery.unavailableTimes.split(","),
          };
        } else if (
          filterTypeOfUnavailableDate === this.dateTypeMapping.DATE &&
          existValueAndEmptyString(routeQuery.unavailableDate)
        ) {
          this.queryByUnavailableDate = {
            ...this.queryByUnavailableDate,
            unavailableDate: DateTime.fromISO(routeQuery.unavailableDate),
          };
        } else if (
          filterTypeOfUnavailableDate === this.dateTypeMapping.WEEK &&
          existValueAndEmptyString(routeQuery.unavailableWorkdaysInWeek)
        ) {
          this.queryByUnavailableDate = {
            ...this.queryByUnavailableDate,
            unavailableWorkdaysInWeek:
              routeQuery.unavailableWorkdaysInWeek.split(","),
          };
        } else if (
          filterTypeOfUnavailableDate === this.dateTypeMapping.MONTH &&
          existValueAndEmptyString(routeQuery.unavailableWorkdaysInMonth)
        ) {
          this.queryByUnavailableDate = {
            ...this.queryByUnavailableDate,
            unavailableWorkdaysInMonth:
              routeQuery.unavailableWorkdaysInMonth.split(","),
          };
        }
      }
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      if (this.query.filterType === this.filterToType.NORMAL) {
        const { count, services } = await this.fetchList();

        this.total = count;
        this.list = services.map((service) => {
          const {
            id,
            name,
            short_description: shortDescription,
            description,
            icon_url: iconUrl
          } = service;
          const provider = {
            ...service.provider,
            logoUrl: service.provider.logo_url
          };
          const route = { name: "ServiceDetailPage", params: { id } };

          return {
            id,
            iconUrl,
            name,
            shortDescription,
            description,
            provider,
            route
          };
        });
      } else if (this.query.filterType === this.filterToType.UNAVAILABLE) {
        const { services, count } = await this.fetchList();

        this.unavailableDateCount = count;
        this.unavailableDateList = services.map((service) => {
          const {
            id,
            name,
            short_description: shortDescription,
            description,
            icon: iconUrl,
            unavailable_date_times,
            unavailable_times,
            unavailable_workdays_in_month,
            unavailable_workdays_in_week,
          } = service;
          const route = { name: "ServiceDetailPage", params: { id } };

          return {
            id,
            iconUrl,
            name,
            shortDescription,
            description,
            route,
            unavailable_date_times,
            unavailable_times,
            unavailable_workdays_in_month,
            unavailable_workdays_in_week
          };
        });
      }
    },

    async fetchList() {
      let response = null;
      if (this.query.filterType === this.filterToType.NORMAL) {
        response = await baanRueJaiClient.admin.subscriptions.services.search(
          this.query
        );
        return response.data.result;
      } else if (this.query.filterType === this.filterToType.UNAVAILABLE) {
        const queryType = this.query.filterTypeOfUnavailableDate;
        const take = 30;
        const page = this.query.page;

        const queryUnavailableDate = this.queryByUnavailableDate;
        let queryString = "";
        if (
          this.checkExistValueAndEmptyArray(
            queryUnavailableDate.unavailableWorkdaysInMonth
          )
        ) {
          queryString = queryUnavailableDate.unavailableWorkdaysInMonth.join(",");
        } else if (
          this.checkExistValueAndEmptyArray(
            queryUnavailableDate.unavailableTimes
          )
        ) {
          queryString = queryUnavailableDate.unavailableTimes.join(",");
        } else if (
          this.checkExistValueAndEmptyArray(
            queryUnavailableDate.unavailableWorkdaysInWeek
          )
        ) {
          queryString = queryUnavailableDate.unavailableWorkdaysInWeek.join(",");
        } else if (
          existValueAndEmptyString(queryUnavailableDate.unavailableDate)
        ) {
          queryString = queryUnavailableDate.unavailableDate.toISO();
        }

        const params = {
          queryType,
          take,
          page,
          queryString,
          page: this.query.page || 1
        };

        try {
          const dateFilterData =
            await baanRueJaiClient.admin.subscriptions.services.searchWithUnavailableDate(
              params
            );
          return dateFilterData.data.result;
        } catch (err) {
          return [];
        }
      }
    },
    async handleClickSearchButton() {
      if (
        this.query.filterType === this.filterToType.UNAVAILABLE
        && !existValueAndEmptyString(this.query.filterTypeOfUnavailableDate)
      ) {
        alert('กรุณาเลือก ประเภทวันที่ไม่สามารถนัดหมายบริการ');
        return
      }

      const query = {
        name: this.query.name,
        providerId: this.selectedProvider
          ? this.selectedProvider.id
          : undefined,
        unavailableDate:
          this.queryByUnavailableDate.unavailableDate !== null
            ? this.queryByUnavailableDate.unavailableDate.toISO()
            : undefined,
        filterType: this.query.filterType,
        unavailableTimes: this.existValueToQuery(
          this.queryByUnavailableDate.unavailableTimes,
          true
        ),
        unavailableWorkdaysInWeek: this.existValueToQuery(
          this.queryByUnavailableDate.unavailableWorkdaysInWeek,
          true
        ),
        unavailableWorkdaysInMonth: this.existValueToQuery(
          this.queryByUnavailableDate.unavailableWorkdaysInMonth,
          true
        ),
        filterTypeOfUnavailableDate: this.query.filterTypeOfUnavailableDate
      };

      this.$router.replace({ ...this.$route, query });
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    },
    async handleClickRemoveUnavailableButton(service) {
      if (!this.queryByUnavailableDate.unavailableDate) {
        alert('เลือกประเภทวันผิด');
        return
      }

      const unavailableDate = this.queryByUnavailableDate.unavailableDate
        .minus({ days: 1 })
        .toISO()
        .slice(0, 10);

      service.unavailable_date_times = service.unavailable_date_times.filter(
        (unavailableDateTimes) =>
          !unavailableDateTimes.includes(unavailableDate)
      );

      const data = {
        unavailableDateTimes: service.unavailable_date_times,
        unavailableTimes: service.unavailable_times,
        unavailableWorkdaysInMonth: service.unavailable_workdays_in_month,
        unavailableWorkdaysInWeek: service.unavailable_workdays_in_week
      };

      try {
        await baanRueJaiClient.admin.subscriptions.services.putWorkdays(
          service.id,
          data
        );

        alert("บันทึกเรียบร้อย");
        this.setupList();
      } catch (error) {
        alert("ไม่สามารถเลือกวันที่ไม่สามารถนัดหมายได้");
        console.error(error);
      }
    },
    handleChangeFilterType() {
      const filterType = this.query.filterType;

      this.query = {
        name: null,
        providerId: null,
        filterType: filterType,
        filterTypeOfUnavailableDate: null,
      };
      this.selectedProvider = null;

      this.setEmptyFilterByUnavailableDate();
    },
    async handleChangeFilterTypeOfUnavailableDate() {
      this.setEmptyFilterByUnavailableDate();

      await this.setupList();
    },
    setEmptyFilterByUnavailableDate() {
      this.queryByUnavailableDate = {
        unavailableWorkdaysInMonth: [],
        unavailableTimes: [],
        unavailableWorkdaysInWeek: [],
        unavailableDate: null,
      };
    },
    existValueToQuery(value, isJoinString = false, typeToEmpty = undefined) {
      if (isJoinString === true) {
        return existValueAndEmptyString(value) && value.length > 0
          ? value.join(",")
          : typeToEmpty;
      }

      return existValueAndEmptyString(value) && value.length > 0
        ? value
        : typeToEmpty;
    },
    handleChangeSelectedUnavailableDate(selectUnavailableDate) {
      this.queryByUnavailableDate.unavailableDate = selectUnavailableDate;
    },
    checkExistValueAndEmptyArray(value) {
      return existValueAndEmptyString(value) && value.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 64px;

.header {
  display: flex;
  flex-flow: row nowrap;
  padding: 30px;
  border-bottom: $border;
  justify-content: space-between;
  background: #f9f9f9;
}
.wrapper {
  padding: ($space / 2) $space;
}
.service-list-item {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;

  align-items: flex-start;

  border-bottom: $border;
  padding: ($space / 2) $space;

  > .icon {
    margin-top: 5px;
    display: block;

    border-radius: 8px;
    width: $logoSize;
    height: $logoSize;
    flex: 0 0 $logoSize;
  }

  > .icon + .meta {
    padding-left: $space;
  }

  > .meta {
    display: block;

    flex-grow: 1;
  }
}

.filter-form {
  background-color: #f9f9f9;
}

.meta {
  min-width: 0;

  > .name {
    display: inline-block;
    font-size: 1rem;

    &:hover {
      color: black;
    }
  }

  > .desc {
    overflow: hidden;
    height: 23px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > .provider {
    margin-top: 5px;
  }
}

.meta p {
  line-height: 1.6;
  font-size: 0.9rem;
  color: #777;
}

.search-service {
  font-size: 0.9rem;
}

.date-calendar {
  .el-checkbox-group {
    display: grid;

    grid-template-columns: repeat(6, 40px);
    padding-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/services/pages/ServiceListPage.vue